var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnFillStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 143.315,
    viewBox: "0 0 150 143.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star",
    "data-name": "Icon feather-star",
    d: "M76.5,1.5a6.818,6.818,0,0,1,6.114,3.8L102.1,44.77l43.571,6.368a6.818,6.818,0,0,1,3.771,11.63l-31.522,30.7,7.439,43.373a6.818,6.818,0,0,1-9.894,7.187L76.5,123.541l-38.963,20.49a6.818,6.818,0,0,1-9.894-7.187l7.439-43.373L3.561,62.769a6.818,6.818,0,0,1,3.771-11.63L50.9,44.77,70.386,5.3A6.818,6.818,0,0,1,76.5,1.5Zm53.533,61.134L96.582,57.745a6.818,6.818,0,0,1-5.128-3.728L76.5,23.722,61.546,54.017a6.818,6.818,0,0,1-5.128,3.728L22.967,62.634l24.2,23.57a6.818,6.818,0,0,1,1.963,6.037l-5.71,33.29L73.326,109.8a6.818,6.818,0,0,1,6.347,0l29.907,15.727-5.71-33.29a6.818,6.818,0,0,1,1.963-6.037Z",
    transform: "translate(-1.5 -1.5)",
    fill: "#674188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnFillStar);
export default __webpack_public_path__ + "static/media/UnFill_Star.bffea0f72f81f59add30de024ce81596.svg";
export { ForwardRef as ReactComponent };